import styled from 'styled-components';

export const MyCashTile = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 16px;
  @media (max-width: 768px) {
    border-radius: 0px;
  }

  & li {
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: solid 1px #d8d8d8;
    padding: 16px;
    @media (max-width: 768px) {
      align-items: flex-start;
    }
  }
  & li.noPadding {
    padding: 0;
    display: block;
  }
  & li:last-of-type {
    border-bottom: none;
  }
`;

export const Details = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 10px;
`;

export const Heading = styled.p`
  color: #4a4a4a;
  font-size: 20px;
  font-weight: 700;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const DescText = styled.p`
  color: #cf8100;
  font-size: 12px;
`;

export const Amount = styled.span`
  font-size: 20px;
  font-weight: 900;
  color: #000;
  margin-left: 20px;
`;

export const AedText = styled.span(
  props => `
    width: '1.4rem'; 
    height: '1.4rem';
  `,
);

export const WalletCashTextLoader = styled.div(
  props => `
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    width: 10rem;
    height: 2.5rem;
  `,
);

export const WalletCashInfoText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.yellow.darkcf};
  `,
);
